import { QueryClient } from '@tanstack/react-query';
import { ApiCallError } from '@/api/client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      gcTime: 10 * 60_000,
      retry: (failures, err) => {
        if (err instanceof ApiCallError && err.status < 500) return false;
        return failures < 2;
      },
    },
    mutations: { retry: false },
  },
});
